// This file is AUTOGENERATED, do not edit it manually!!!

export const projectFinancials = {
    actual_billing: 'Actual billable',
    actual_cost: 'Actual cost',
    ActualBillableExpenses: 'Actual billable expenses',
    ActualBillableExpensesShort: 'Actual billable expenses',
    ActualBilledShort: 'Actual invoiced',
    ActualBillingShort: 'Actual billable',
    ActualBudgetProfitability: 'Actual budget perform',
    ActualCost: 'Actual cost',
    ActualCostQtip: 'Actual cost = Actual labor cost + Actual expenses',
    ActualExpenses: 'Actual expenses',
    ActualExpensesListTitle: 'Actual',
    ActualExpensesShort: 'Actual expenses',
    ActualHours: 'Actual hours',
    ActualLaborBilling: 'Actual billable labor',
    ActualLaborBillingShort: 'Actual billable labor',
    ActualLaborCost: 'Actual labor cost',
    ActualLaborCostShort: 'Actual labor cost',
    add_activities_flat_fees: 'add activities flat fees',
    add_as_actual_expense: 'Add as actual expense',
    add_planned_billable_expenses: 'add planned billable expenses',
    add_received_payment: 'Add received payment',
    add_scheduled_payment: 'Add scheduled payment',
    AddActivitiesBudgets: 'add activities budgets',
    AddBudgetLabel: 'Add budget for this project',
    AddPlannedExpenses: 'add planned expenses',
    Amount: 'Amount',
    approver_label: 'Approver',
    approvers_problem_warning: 'One of the approvers can no longer approve expenses. Update the approvers list.',
    ApproveTooltip: 'Transfers planned expenses to actual ones',
    back_to_metrics: 'Back to metrics',
    batch_actual_text: 'Add as Actual expenses',
    batch_approval_text: 'Approve expenses',
    batch_billed_text: 'Mark as invoiced',
    batch_operation_failed_description: 'The operation could not be completed for this expenses. This may be due to its having been deleted or lacking permissions to perform operations with it. Consult with your {brandName} administrator for possible causes.',
    batch_operations_failed_description: 'The operation could not be completed for {0} out of {1} expenses. This may be due to them having been deleted or lacking permissions to perform operations with them. Consult with your {brandName} administrator for possible causes.',
    batch_reject_text: 'Reject expenses',
    Billable: 'Billable',
    Billed: 'Invoiced',
    BilledPercentQtip: 'Invoiced = (Invoiced labor + Invoiced expenses) / EAC billable * 100%',
    BilledVsActualCost: 'Invoiced vs Actual cost',
    Billing: 'Billable',
    Billing_Info_Title: 'Billing info',
    billing_type_item_readonly: 'Editing is not available in the grid when the billing type is Rate card. You can edit it in the Financials section',
    BillingHelp: 'In the Billing section you can choose the right type of billing for your project and set a rate, such as hourly, or a fixed amount for a flat fee project.',
    BillingSettings: 'Billing settings',
    BillingSettingsTitle: 'Billing',
    BillingType: 'Billing type',
    BillingTypeLabel: 'Calculate by ',
    BillingUtilization: 'Upfront billing utilization',
    BudgetedCost: 'Total project budget',
    BudgetHelp: 'In this section you can view the total budget of the project as composed of that of all its activities, and set a project level budget.',
    CancelTooltip: 'Cancel',
    chart_actual_billing: 'Actual billable',
    chart_actual_cost: 'Actual cost',
    chart_billable_expenses: 'Billable expenses',
    chart_billed: 'Invoiced',
    chart_billed_expenses: 'Invoiced expenses',
    chart_eac_billing: 'EAC billable',
    chart_expenses: 'Expenses',
    chart_non_billable_expenses: 'Non-billable expenses',
    chart_payments: 'Received payments',
    chart_scheduled_payments: 'Scheduled payments',
    ContingencyPadding: 'Contingency',
    Cost: 'Total cost',
    CPI: 'CPI',
    CurrencyLabel: 'Currency',
    CustomerHourlyRateLabel: 'Customer hourly rate',
    Date: 'Date',
    delete_the_expense_title: 'Delete the expense',
    delete_the_payment_title: 'Delete the payment',
    DeletePaymentConfirmation: 'Are you sure you want delete this record?',
    DeleteTooltip: 'Delete',
    Description: 'Description',
    DetailedReportTitleTemplate: 'Detailed report for {0}',
    EAC: 'Estimate at completion',
    eac_billing: 'Estimate at completion (EAC) billable',
    eac_cost: 'Estimate at completion (EAC) cost',
    EACBilling: 'EAC billable',
    EACBillingLong: 'Estimate at completion (EAC) billable',
    EACBillingQtip: 'Estimate at completion (EAC) billable = Actual billable + ETC billable',
    EACBillingQtipInfo: 'Estimated total billable amount including billable labor and billable expenses (Actual + Estimate to completion (ETC))',
    EACCost: 'Estimate at completion (EAC) cost',
    EACCost_short: 'EAC cost',
    EACCostQtip: 'Estimate at completion (EAC) cost = Actual cost + ETC cost',
    EnteredBy: 'Entered by',
    EstimatedBudgetProfitability: 'Estimated budget profitability',
    EstimatedCostVariance: 'Estimated cost variance',
    EstimatedExpenses: 'Estimated expenses',
    EstimatedHours: 'Estimated hours',
    EstimatedProfit: 'Expected profit',
    EstimatedProfitPercentQtip: 'Expected profit (%) = (EAC billable - EAC cost) / EAC billable * 100%',
    EstimatedProfitQtip: 'Expected profit = EAC billable - EAC cost',
    etc_billing: 'Estimate to completion (ETC) billable',
    etc_cost: 'Estimate to completion (ETC) cost',
    ETCBillableExpenses: 'ETC billable expenses',
    ETCBillableExpensesShort: 'ETC billable expenses',
    ETCBilling: 'ETC billable',
    ETCBillingShort: 'ETC billable',
    ETCCost: 'ETC cost',
    ETCCostShort: 'ETC cost',
    ETCCosttQtip: 'Estimate to completion (ETC) cost = ETC labor cost + ETC expenses',
    ETCExpenses: 'ETC expenses',
    ETCExpensesShort: 'ETC expenses',
    ETCLaborBilling: 'ETC billable labor',
    ETCLaborBillingShort: 'ETC billable labor',
    ETCLaborCost: 'ETC labor cost',
    ETCLaborCostShort: 'ETC labor cost',
    ExpectedRevenue: 'Expected revenue',
    expenses: '1#{0} expense#{0} expenses',
    expenses_approval_info: 'Enables expenses approval for the entire project and all its activities.',
    expenses_approval_label: 'Expenses approval',
    expenses_approval_remove_all_approvers_title: 'Removes all approvers, which disables the expense approval process after saving.',
    expenses_approval_status_approved: 'Approved',
    expenses_approval_status_has_been_successfully_undone: '1#Approval has been successfully undone#{0} approvals have been successfully undone',
    expenses_approval_status_none: 'Waiting for approval',
    expenses_approval_status_rejected: 'Rejected',
    expenses_approved_successfully_plural: '1#Expense has been approved#{0} expenses have been approved',
    expenses_rejected_successfully_plural: '1#Expense has been rejected#{0} expenses have been rejected',
    expenses_updated_successfully_plural: '1#Expenses has been updated successfully.#{0} expenses have been updated successfully.',
    FeeAmount: 'Fee amount',
    FlatFee: 'Flat fee',
    GeneralInfo: 'General info',
    HourlyRate: 'Hourly rate',
    InternalBudget: 'Budget',
    InternalEstimatedCost: 'Estimated cost',
    LaborBilling: 'Billable labor',
    LaborCost: 'Labor cost',
    legend_actual: 'Actual',
    legend_estimated_at_completion: 'Estimate at completion',
    log_actual_expense: 'Log actual expense',
    log_expenses: 'Log expenses',
    log_payments: 'Log payments',
    log_planned_expense: 'Log planned expense',
    money_for_date_label: '{0} for {1}?',
    no_targets: 'No targets to display',
    NoActualExpenses: 'There are no expenses.',
    None: 'None',
    NoneCurrency: 'Choose currency',
    NoPayments: 'There are no payments.',
    NoPlannedExpenses: 'There are no planned expenses.',
    NotBillable: 'Not billable',
    NotBillableLabel: 'Not billable',
    NotBilled: 'Not invoiced',
    OpenRateCard: 'Open rate card',
    OutstandingPaymentBalance: 'Outstanding payment balance',
    PaymentDescriptionWatermark: 'Description...',
    PaymentReceived: 'Payment received',
    payments_total: '1#{0} payment#{0} payments',
    PaymentsOfSchedPayments: 'Payments of sched. payments',
    PercentageBilled: 'Percentage invoiced',
    PercentageProjectBilled: 'Percentage invoiced',
    Percentages: 'Percentage',
    PlannedExpenses: 'Planned expenses',
    PlannedExpensesListTitle: 'Planned',
    ppFormat: '{0}pp',
    Profit: 'Profit',
    ProfitQtip: 'Profit = Actual billable - Actual cost',
    Project_no_rateCard_for_rateCard_billingType: 'You must specify a rate card if project billing is based on rate card.',
    ProjectActivityName: 'Project / Activity name',
    ProjectBilling: 'Project billing',
    ProjectBillingIsBasedOn: 'Project billing is based on',
    ProjectBillingUtilization: 'Billing utilization',
    ProjectBudget: 'Labor budget',
    ProjectCost: 'Project internal cost',
    ProjectCostVariance: 'Project cost variance',
    ProjectEarnedValue: 'Project earned value',
    ProjectEarnedValueInfo: 'Represents project health',
    ProjectExpectedRevenue: 'Project expected revenue',
    ProjectFixedCostLabel: 'Project flat fee',
    ProjectHourlyRateLabel: 'Project hourly rate',
    ProjectPayments: 'Project payments',
    ProjectPlannedExpenses: 'Project planned expenses',
    ProjectPlannedExpensesInfo: 'Expenses planned for a specific project and planned expenses aggregated from its activities',
    ProjectProfit: 'Project profit',
    ProjectProfitability: 'Project profitability',
    ProjectProfitabilityInfo: 'Represents  the percentage of value created per project',
    ProjectTimeUsage: 'Project time usage',
    ProjectTimeUsageInfo: 'Displays how much of the time budgeted we\'ve used, actual as a percentage of estimated hours',
    ProjectWorkInProgress: 'Project work in progress',
    PymentsVsActualCost: 'Payments vs Actual cost',
    RateCardLabel: 'Rate card',
    Receipt: 'Receipt',
    Received: 'Received',
    ReceivedPaymentsListTitle: 'Received',
    RemainingInternalBudget: 'Remaining budget',
    RemainingInternalBudgetQtip: 'Remaining budget = Budget - Actual cost',
    RemainingInternalBudgetQtipForProject: 'Remaining budget = Total budget - Actual cost',
    ResourceHourlyRateLabel: 'Resource hourly rate',
    Revenue: 'Revenue',
    revert_approval_text: 'Editing this expense will reset its status to Waiting for approval and restart the approval process from the beginning. Any previous approvals or rejections will be lost. Do you want to proceed?',
    revert_approval_title: 'Revert expense for reapproval?',
    Scheduled: 'Scheduled',
    ScheduledPaymentsListTitle: 'Scheduled',
    set_targets: 'Set targets using the',
    Settings: 'Settings',
    show_expenses_waiting_for_my_approval: 'Waiting for approval from me',
    ShowAll: 'SHOW ALL',
    ShowBreakdown: 'Show breakdown',
    ShowFull: 'SHOW FULL',
    SPI: 'SPI',
    status_label: 'Status',
    tab_Actual: 'Actual expenses',
    tab_expenses: 'Expenses',
    tab_overview: 'Overview',
    tab_payments: 'Payments',
    tab_Planned: 'Planned expenses',
    tab_Received: 'Received payments',
    tab_Scheduled: 'Scheduled payments',
    tab_targets: 'Targets',
    TargetBudget: 'Total budget',
    TargetLaborRevenue: 'Target labor revenue',
    TargetProfit: 'Target profit',
    TargetRevenue: 'Target revenue',
    Targets: 'Targets',
    targets_tab: 'Targets tab',
    TargetsEACBilling: 'EAC billable',
    TaskRateLabel: 'Activity rate',
    TimeAndMaterial: 'Time & material',
    TimeUsage: 'Time usage',
    TitleText: 'Financials',
    total_billable: 'Total billable',
    TotalBilled: 'Total invoiced',
    TotalProjectBudget: 'Total project budget',
    TotalProjectPayments: 'Total project payments',
    TotalProjectPaymentsInfo: 'Summary of all payments made by all customers',
    TotalTargetRevenue: 'Total target revenue',
    TrackProfitAs: 'Track profit as',
    Validation_DateMandatory: 'Date is a required field.',
    Validation_InvalidAmount: 'Amount must be positive number.',
    Validation_InvalidDate: 'Date must be in \'{0}\' format.',
    Validation_Range: 'Value doesn\'t fall within the expected range.',
    Variance: 'Variance',
    warning_currency: 'Currency is taken from chosen rate card',
    WorkInProgress: 'Work in progress',
};
